var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ThreeColumnLayout',[_c('main',{staticClass:"page"},[_c('p',{staticClass:"page__placeholder"},[_vm._v("Participation validée — contenu à intégrer")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }